import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaMenu12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMegaMenu12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-9a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5m-9-1A1.5 1.5 0 0 0 0 2.5v6A1.5 1.5 0 0 0 1.5 10h9A1.5 1.5 0 0 0 12 8.5v-6A1.5 1.5 0 0 0 10.5 1zm1 2.5A.5.5 0 0 1 3 3h2a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5M3 5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 3 7h1a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5M7 5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 7 7h1a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5M7 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaMenu12);
